"use client";

import MarketingNav from "~/app/components/marketing-nav";
import MarketingFooter from "~/app/components/marketing-footer";

export default function FeaturesLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <MarketingNav />
      <main>{children}</main>
      <MarketingFooter isLanding={false} />
    </div>
  );
}
